import { render } from "./VerifyPoints.vue?vue&type=template&id=3cc9163f"
import script from "./VerifyPoints.vue?vue&type=script&lang=js"
export * from "./VerifyPoints.vue?vue&type=script&lang=js"

import exportComponent from "/data/soft/jenkins/workspace/S09_ehm-acsecurity-pro-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__